import { PhotoSessionDetailLoadable } from 'containers/PhotoSessionDetail/PhotoSessionDetailLoadable';
import { PhotoSessionsLoadable } from 'containers/PhotoSessions/PhotoSessionsLoadable';
import ROUTES, { routesNames } from './constants';

const createPhotoSessionsRoutes = () =>
  [
    {
      path: ROUTES.NOT_STARTED_PHOTO_SESSIONS,
      name: routesNames.notStartedPhotoSessions,
      component: PhotoSessionsLoadable,
      exact: true,
    },
    {
      path: ROUTES.RESCHEDULE_PHOTO_SESSIONS,
      name: routesNames.reschedulePhotoSessions,
      component: PhotoSessionsLoadable,
      exact: true,
    },
    {
      path: ROUTES.STARTED_PHOTO_SESSIONS,
      name: routesNames.startedPhotoSessions,
      component: PhotoSessionsLoadable,
      exact: true,
    },
    {
      path: `${ROUTES.PHOTO_SESSION_DETAIL}:id`,
      name: routesNames.photoSessionDetail,
      component: PhotoSessionDetailLoadable,
      exact: true,
    },
  ];

export default createPhotoSessionsRoutes;
